<template>
    <transition name="modal">
        <div class="modal-mask">
            <div
                class="modal-dialog"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="product-title">{{ product.name }}</h2>
                        <button @click="$emit('close')">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>

                    <div class="modal-body">
                        <p
                            class="alert alert-info"
                            v-if="message"
                        >
                            {{ message }}
                        </p>
                        <div
                            class="overlay"
                            v-if="loading"
                        >
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                        <label
                            >Color:<label style="margin-left: 5px">{{ colorName }}</label></label
                        >
                        <ul class="filter-color-list">
                            <li
                                v-for="(color, index) in this.colors"
                                :class="{ active: index === activeIndex }"
                            >
                                <span
                                    class="filter-color"
                                    @click="setColor(color, index)"
                                    :style="{ 'background-color': color.color }"
                                ></span>
                            </li>
                        </ul>

                        <label class="product-label">
                            <label>サイズ:</label>
                            <label>個数：</label>
                            <label>金額：</label>
                        </label>
                        <ul class="filter-size-list">
                            <li v-for="(size, index) in sizes">
                                <div class="product-action">
                                    <div class="item filter-size-name">
                                        {{ size.name }}
                                    </div>

                                    <div
                                        class="item product-quantity-item"
                                        style="z-index: 0"
                                    >
                                        <input
                                            v-model="size.count"
                                            type="text"
                                        />
                                        <span class="input-group-btn-vertical">
                                            <button
                                                @click="size.count++, (size.active = true)"
                                                class="btn-up"
                                                type="button"
                                            >
                                                <i class="glyphicon glyphicon-plus"></i>
                                            </button>
                                            <button
                                                @click="
                                                    size.count > 0 ? size.count-- : 0,
                                                        size.count === 0
                                                            ? (size.active = false)
                                                            : ''
                                                "
                                                class="btn-down"
                                                type="button"
                                            >
                                                <i class="glyphicon glyphicon-minus"></i>
                                            </button>
                                        </span>
                                    </div>

                                    <div class="item product-price">
                                        <span v-if="Number(size.price_jpy) === 0">
                                            ask
                                        </span>
                                        <span v-else>
                                            ￥{{ Number(size.price_jpy).toLocaleString() }}
                                        </span>
                                    </div>

                                    <div class="item">
                                        <button
                                            v-bind:disabled="size.count === 0"
                                            class="col-lg-2 btn btn-accent btn-addtobag"
                                            style="z-index: 0"
                                            @click="addCart(size)"
                                        >
                                            レンタルする
                                        </button>
                                    </div>

                                    <input
                                        v-bind:disabled="size.count === 0"
                                        type="checkbox"
                                        :value="size.id"
                                        v-model="size.active"
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="modal-footer">
                        <div class="btn-alltobag">
                            <button
                                :disabled="!allCartDisabled"
                                class="btn-alltobag btn btn-accent"
                                @click="addCartMulti"
                            >
                                まとめてレンタルする
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import linq from 'linq'
import { addCartItem } from '../../services/CartService'

export default {
    name: 'product-modal',

    data() {
        return {
            colors: [],
            sizes: [],
            activeColor: null,
            activeSize: [],
            activeIndex: null,
            loading: false,
            colorName: '',
            message: '',
        }
    },

    props: {
        product: {
            type: Object,
        },
    },

    computed: {
        allCartDisabled: function () {
            return linq.from(this.sizes).any(function (x) {
                return x.active
            })
        },
    },

    async created() {
        await this.getColors()
        await this.setColor(this.colors[0], 0)
    },

    methods: {
        async setColor(color, i) {
            this.activeIndex = i
            this.activeColor = color
            this.colorName = color.name
            await this.getSizes()
        },

        async getColors() {
            this.colors = []
            const { data } = await axios.get(`/api/product/${this.product.id}/color`)
            linq.from(data)
                .select((x) => this.colors.push(x.color))
                .toArray()
        },

        async getSizes() {
            this.sizes = []
            this.loading = true

            const { data } = await axios.get(
                `/api/product/${this.product.id}/size/${this.activeColor.id}`
            )

            linq.from(data.data)
                .select((x) => {
                    let data = x.size
                    data.item_id = x.item_id
                    data.price_jpy = x.price_jpy
                    data.count = 0
                    data.active = false
                    this.sizes.push(data)
                })
                .toArray()
            this.loading = false
        },

        async addCartMulti() {
            this.loading = true
            this.setMessage()

            const items = linq
                .from(this.sizes)
                .where((x) => x.active)
                .toArray()

            const is_success = await addCartItem(items)
            this.resetSizes()

            if (is_success) {
                this.setMessage('カートを更新しました')
                this.addCartAction()
            }

            this.loading = false
        },

        async addCart(size) {
            this.loading = true
            this.setMessage()

            const items = [size]
            const is_success = await addCartItem(items)
            size.count = 0
            size.active = false

            if (is_success) {
                this.setMessage('カートを更新しました')
                this.addCartAction()
            }
            this.loading = false
        },

        resetSizes() {
            linq.from(this.sizes)
                .select((x) => {
                    x.count = 0
                    x.active = false
                })
                .toArray()
        },

        addCartAction() {
            window.cartDrop.$emit('getCartItems')
        },

        setMessage(message = '') {
            this.message = message
        },
    },
}
</script>

<style lang="scss">
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}
.modal-header {
    display: flex;
}
.modal-header h2 {
    margin-bottom: 0;
}
.modal-header button {
    position: absolute;
    right: 20px;
    top: 5px;
    border: 0;
    font-size: 20px;
    background-color: #fff;
}

.modal-body {
    margin: 20px 0;
    max-height: 70vh;
}

.btn-alltobag button {
    background-color: #fff;
    color: #000;
    text-align: right;
    font-weight: 700;
    &:hover {
        color: #fff;
        border-color: #262634;
        background-color: #262634;
    }
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/products/ProductModal.vue